import {
  enumItemAliasType,
  ItemAliasRecord,
  ItemAliasType,
} from '../types/inventoryItem';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const itemAliasDetailQueryAtom = createQueryAtomFactory(
  'settings.itemAliasDetail',
  (_: { ids: string[] }) => ({
    // itemAliases: {
    //   __args: {
    //     filter: {
    //       ids: params.ids,
    //     },
    //     pagination: {
    //       limit: 1,
    //       offset: 0,
    //     },
    //   },
    //   entries: {
    //     id: true,
    //     itemId: true,
    //     item: {
    //       id: true,
    //       name: true,
    //     },
    //     accountId: true,
    //     account: {
    //       id: true,
    //       name: true,
    //     },
    //     aliasName: true,
    //     aliasCode: true,
    //     aliasType: true,
    //     notes: true,
    //     timestamps: {
    //       createdAt: true,
    //       updatedAt: true,
    //     },
    //   },
    // },
  }),
  {
    mock: {
      itemAlias: {
        id: 'itemalias_01HXYZ123456789ABCDE',
        itemId: 'item_01HXYZ123456789ABCDEFGH',
        item: { id: 'item_01HXYZ123456789ABCDEFGH', name: 'Copper Wire #1' },
        accountId: 'account_01HXYZ123456789ABCDEF',
        account: {
          id: 'account_01HXYZ123456789ABCDEF',
          name: 'ABC Supplier',
        },
        aliasName: 'CW1-Premium',
        aliasCode: 'CW1P',
        aliasType: enumItemAliasType.Buy as ItemAliasType,
        notes: 'Customer preferred naming',
        timestamps: {
          createdAt: parseZonedDateTime('2024-01-15T00:00:00+00:00[UTC]'),
          updatedAt: parseZonedDateTime('2024-01-15T00:00:00+00:00[UTC]'),
        },
      } satisfies ItemAliasRecord,
    },
  },
);
